import styled from 'styled-components';

export const ResourceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
